const resources = { backToTop: 'Retour en haut de page' };

export default function getResource(label) {
    return resources[label];
}
